<div class="content-recaptcha-integrator">
    <div class="about-recaptcha">
        <p>Configure o reCAPTCHA V2 em sua página de login. O reCAPTCHA protege contra acessos não autorizados, garantindo
            a
            segurança dos dados.
            <a 
            target="_blank"
            href="https://crmrubeus.zendesk.com/hc/pt-br/articles/28522744775181-Integra%C3%A7%C3%A3o-com-Google-reCAPTCHA-e-a-Ficha-de-Inscri%C3%A7%C3%B5es-e-Matr%C3%ADculas-Rubeus">
                Saiba mais
            </a>
        </p>
    </div>
    <form [formGroup]="form" (ngSubmit)="onDialog()">
        <div fxLayout="row" class="ps-row">
            <div class="ps-form-captcha">
                <mat-form-field appearance="fill" class="ps-form-margin" fxFlex>
                    <mat-label>Token</mat-label>
                    <input class="input-recaptcha" matInput type="text" formControlName="token" required #input>
                    <span></span>
                    <mat-hint class="mat-hint-form">Informe aqui o token</mat-hint>
                    <mat-error *ngIf="form.controls.token.hasError('required')">
                        Campo obrigatório
                    </mat-error>
                </mat-form-field>
                <mat-form-field appearance="fill" class="ps-form-margin" *ngIf="changingCredentials" fxFlex>
                    <mat-label>Secret Key</mat-label>
                    <input matInput type="text" class="input-recaptcha" formControlName="secret_key" required #input>
                    <mat-hint class="mat-hint-form">Chave de acesso fornecida pelo reCAPTCHA</mat-hint>
                    <mat-error *ngIf="form.controls.token.hasError('required')">
                        Campo obrigatório
                    </mat-error>
                </mat-form-field>
                <div class="ps-portal-content-test-tbc" fxLayout.sm="column" fxLayout.xs="column" fxLayout="row"
                    fxLayoutAlign="start center" fxLayoutAlign.xs="start start" fxLayoutAlign.sm="start start"
                    *ngIf="dataSuccess">
                    <div fxLayout="row" fxLayoutGap="16px" fxLayoutAlign="center center" fxLayoutAlign.xs="start start">
                        <button type="button" class="btn-portal-test-tbc" mat-stroked-button
                            (click)="changeCredentials()">
                            {{ changingCredentials ? 'Manter' : 'Alterar' }} credências
                        </button>
                    </div>
                </div>
                <div class="ps-portal-content-test-tbc" fxLayout.sm="column" fxLayout.xs="column" fxLayout="row"
                    fxLayoutAlign="start center" fxLayoutAlign.xs="start start" fxLayoutAlign.sm="start start"
                    *ngIf="changingCredentials">
                    <div fxLayout="row" fxLayoutGap="16px" fxLayoutAlign="center center" fxLayoutAlign.xs="start start">
                        <button type="button" class="btn-portal-test-tbc" mat-stroked-button [disabled]="!buttonVerify"
                            (click)="verifyCredentials()">
                            Verificar credências
                        </button>
                    </div>
                </div>
                <div class="toggle-recaptcha">
                    <mat-slide-toggle formControlName="active" color="primary">
                        <span
                            [ngClass]="{ 'captcha-toogle-active': this.form.controls.active.value, 'captcha-toogle-disabled': !this.form.controls.active.value }">
                            {{this.form.controls.active.value ? 'Habilitado' : "Desabilitado"}}
                        </span>
                    </mat-slide-toggle>
                </div>
            </div>
        </div>
        <div class="ps-alert-credits" *ngIf="dataSuccess">
            <span>Atenção!</span> A funcionalidade do reCAPTCHA será desabilitada na tela de login caso não haja
            créditos de avaliações
        </div>
        <div id="widgets"></div>
        <app-save-editions [form]="form" [date]="date" (clickClearAlternateChanges)="resetValidation()" [lastChange]="dataSuccess">
        </app-save-editions>
    </form>
</div>